import '@adornis/bh-matching-frontend-entrypoint/matching-page-admin.js';
import { initAdminRouter } from '@adornis/bh-matching-frontend-entrypoint/matching-page-admin.js';
import { ChemistryLitElement } from '@adornis/chemistry/chemistry-lit-element.js';
import '@adornis/forms/x-radiogroup';
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { AccompanyingBuddyFfmUser, BuddyFfmUser } from '../entities/buddy-ffm-users.js';

export const adminRouter = initAdminRouter({
  configOverrides: {},
  mentorUserClass: AccompanyingBuddyFfmUser,
  menteeUserClass: BuddyFfmUser,
  fieldsOverride: userClass => {
    if (userClass._class === AccompanyingBuddyFfmUser._class) {
      const registrationFields = [
        'firstName',
        'lastName',
        'gender',
        'age',
        'email',
        'emailRepeat',
        'phone',
        'matrikelNummer',

        'department',
        'mainSubject',
        'extraSubject',
        'angestrebterAbschluss',
        'semester',
        'studiedAbroad',

        'nativeLanguage',
        'germanLanguageLevel',
        'foreignLanguages',
        'hobbies',
        'isFirstBBuddyApplication',
        'motivationMentor',
        'departmentPreference',
        'genderPreference',
        'sonstigesNotes',
        'privacyPolicy',
      ];

      return Object.values(AccompanyingBuddyFfmUser.fields)
        .filter(field => registrationFields.includes(field.name))
        .sort((a, b) => registrationFields.indexOf(a.name) - registrationFields.indexOf(b.name));
    }

    if (userClass._class === BuddyFfmUser._class) {
      const registrationFields = [
        'firstName',
        'lastName',
        'gender',
        'age',
        'email',
        'emailRepeat',
        'phone',
        'matrikelNummer',

        'department',
        'mainSubject',
        'extraSubject',
        'angestrebterAbschluss',
        'semester',
        'herkunftsland',
        'erasmusStudent',

        'nativeLanguage',
        'germanLanguageLevel',
        'foreignLanguages',
        'hobbies',
        'isFirstIBuddyApplication',
        'expectationsForBuddyMatching',
        'departmentPreference',
        'genderPreference',
        'arrivalType',
        'arrivalDate',
        'sonstigesNotes',
        'privacyPolicy',
      ];
      return Object.values(BuddyFfmUser.fields)
        .filter(field => registrationFields.includes(field.name))
        .sort((a, b) => registrationFields.indexOf(a.name) - registrationFields.indexOf(b.name));
    }

    console.log('unknown user class', userClass);
    return [];
  },
});

adminRouter.init();

@customElement('main-element')
export class MainElement extends ChemistryLitElement {
  override render() {
    return html`<matching-page-admin></matching-page-admin>`;
  }
}
